import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePriority, Priority } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<Priority>
      useData={usePriority}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
